import { useEffect } from "react";
import {
  API_LIQUIDATIONS_CONFIGURABLE,
  API_LOAD_LIQUIDATIONS_MERCHANT,
} from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_LIQUIDATION_CONFIGURABLES } from "../../utils/urls";
import useGet from "../common/useGet";

const url = URL_LIQUIDATION_CONFIGURABLES;

export const useLiquidationsConfigurablesForm = ({ id }) => {
  const isEdit = !!id;
  const { loadData, loading, data } = useGet();

  useEffect(() => {
    loadData({ api: API_LOAD_LIQUIDATIONS_MERCHANT });
  }, []);
  const sections: any = [
    {
      title: "Liquidations Details",
      fields: [
        {
          field_name: "collection_merchant",
          label: "Collection Merchant",
          type: "select",
          description:
            "Select the merchant responsible for collecting funds before liquidation. This merchant initiates the collection process.",
          props: { required: !isEdit, placeholder: "Select merchant..." },
          options_data: data,
          loading,
        },
        {
          field_name: "liquidation_merchant",
          label: "Liquidation Merchant",
          type: "select",
          description:
            "Select the merchant who will receive the funds after liquidation is completed.",
          props: { required: !isEdit, placeholder: "Select merchant..." },
          options_data: data,
          loading,
        },
        {
          field_name: "floor_threshold_amount",
          type: "number",
          description:
            "Enter the minimum amount that must be collected before triggering a liquidation event.",
          props: { required: !isEdit },
        },
        {
          field_name: "ceiling_threshold_amount",
          type: "number",
          description:
            "Enter the maximum amount limit for a single liquidation. Amounts above this threshold may require additional approval or processing.",
          props: { required: !isEdit },
        },
        {
          field_name: "duration_unit",
          type: "select",
          description:
            "Select the time unit used to measure the liquidation duration, such as hours or minutes.",
          props: { required: !isEdit },
          options_data: [
            { id: "Hours", name: "Hours" },
            { id: "Minutes", name: "Minutes" },
          ],
        },
        {
          field_name: "durations",
          type: "number",
          description:
            "Enter the duration value for liquidation based on the selected duration unit. This determines how often liquidations occur.",
          props: { required: !isEdit },
        },
        {
          field_name: "is_active",
          type: "checkbox",
          description:
            "Toggle to mark this liquidation rule as active or inactive. Only active rules will be applied.",
          props: { required: !isEdit },
          visible: isEdit,
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  function onSubmit(payload: any, id: string | number) {
    if (id) {
      return {
        id,
        api: `${API_LIQUIDATIONS_CONFIGURABLE}`,
        params: {
          ...payload,
        },
      };
    }

    //   CREATE
    return {
      api: `${API_LIQUIDATIONS_CONFIGURABLE}`,
      params: {
        ...payload,
      },
    };
  }

  return { sections, redirect, onSubmit };
};
